/**
 * Preview Host Detection
 * 
 * Detects if the app is running in a Lovable preview environment
 * to disable PWA/caching behaviors that cause instability.
 */

/**
 * Check if current host is a Lovable preview environment
 * Preview hosts match patterns like:
 * - id-preview--*.lovable.app
 * - *.lovableproject.com
 */
export function isPreviewHost(): boolean {
  if (typeof window === 'undefined') return false;
  
  const hostname = window.location.hostname;
  
  return (
    hostname.includes('.lovableproject.com') ||
    hostname.includes('lovable.app') ||
    hostname.startsWith('id-preview--') ||
    hostname.includes('-preview--')
  );
}

/**
 * Check if we should enable PWA features
 * Only enable on production hosts (not preview)
 */
export function shouldEnablePWA(): boolean {
  return import.meta.env.PROD && !isPreviewHost();
}
